<template>
  <div>
    <div style="text-align: left">
      <el-select
        v-if="userRole != 'Student'"
        v-model="currentViewingTeacherId"
        filterable
        class="m-2"
        placeholder="选择老师"
        @change="handleSelectTeacherChange"
      >
        <el-option
          v-for="item in teachersAndAdmins"
          :key="item.userId"
          :label="item.userName"
          :value="item.userId"
        />
      </el-select>

      <el-button
        v-if="userRole != 'Student'"
        @click="duplicateMultipleTests"
        style="margin-left: 10px"
        >批量复制</el-button
      >

      <el-button @click="clearFilter">清除过滤</el-button>

      <el-button
        v-if="userRole != 'Student'"
        type="primary"
        @click="generateReport"
        style="margin-left: 10px"
        >生成报告</el-button
      >
    </div>
    <el-table
      ref="allTestTable"
      :data="filterTestList"
      style="width: 80%"
      :row-class-name="tableRowClassName"
      @row-click="
        (row, column, event) => {
          handleTestListRowClick(row, column, event);
        }
      "
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="userRole != 'Student'"
        type="selection"
        width="55"
      />
      <el-table-column prop="name" min-width="180">
        <template #header>
          <div class="test-list-name-header">
            <el-input
              v-model="searchName"
              size="small"
              clearable
              placeholder="按测试名称搜索"
            />
          </div>
        </template>
        <template #default="scope">
          <span class="test-list-name-cell">
            <el-tag
              v-if="isAndoverAssigned(scope.row)"
              size="small"
              type="warning"
              effect="plain"
              disable-transitions
              class="andover-test-tag"
              title="Andover_Vocabulary"
              @click.stop
              >Andover</el-tag
            >
            <span>{{ scope.row.name }}</span>
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column
      prop="createdDate"
      label="创建日期"
      sortable
      width="180"
      column-key="date"
    /> -->
      <el-table-column
        property="createdDate"
        label="创建日期"
        sortable
        width="180"
        column-key="createdDate"
      >
        <template #default="scope">
          {{ scope.row.createdDate.substring(5, 10) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="模式"
        width="150"
        :filters="[
          { text: '听写英文', value: 1 },
          { text: '听写中英', value: 2 },
          { text: '听英写中', value: 3 },
          { text: '看英写中', value: 4 },
          { text: '语音测试', value: 5 },
          { text: '看中写英', value: 6 },
        ]"
        :filter-method="filterType"
        filter-placement="bottom-end"
      >
        <template #default="scope">
          {{ testTypeString(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column min-width="200">
        <template #header>
          <div class="test-list-origin-header">
            <span class="test-list-origin-label">来源</span>
            <el-select
              v-model="searchOrigin"
              size="small"
              clearable
              filterable
              placeholder="筛选来源"
              class="test-list-origin-select"
            >
              <el-option
                v-for="o in originOptions"
                :key="o"
                :label="o"
                :value="o"
              />
            </el-select>
          </div>
        </template>
        <template #default="scope">
          <el-popover
            effect="light"
            trigger="hover"
            placement="top"
            width="auto"
          >
            <template #default>
              <div class="test-list-origin-pop">
                <div class="test-list-origin-pop-text">
                  origin: {{ scope.row.origin }}
                </div>
                <el-button
                  size="small"
                  type="primary"
                  text
                  @click.stop="filterByOrigin(scope.row)"
                  >仅看此来源</el-button
                >
              </div>
            </template>
            <template #reference>
              <span class="test-list-origin-ref">
                {{ scope.row.origin.substring(0, 20) + "..." }}
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述"> </el-table-column>

      <el-table-column
        prop="category"
        label="类别"
        width="150"
        :filters="[
          { text: '词测', value: '词测' },
          { text: '默写', value: '默写' },
          { text: '常规词汇机筛', value: '常规词汇机筛' },
          { text: '星标词检查', value: '星标词检查' },
          { text: '无', value: 'None' },
        ]"
        :filter-method="filterCategory"
        filter-placement="bottom-end"
      >
        <template #default="scope">
          {{ scope.row.category }}
        </template>
      </el-table-column>

      <el-table-column
        prop="status"
        label="状态"
        width="100"
        :filters="[
          { text: 'standing', value: 'standing' },
          { text: 'pending', value: 'pending' },
          { text: 'finished', value: 'finished' },
        ]"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
      >
        <template #default="scope">
          <el-tag
            :type="scope.row.status === 'finished' ? '' : 'success'"
            disable-transitions
            >{{ scope.row.status }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column width="200" header-align="left" align="left">
        <template #header>
          <span
            class="test-score-header"
            title="点击加载尚未显示成绩的已完成测试"
            @click.stop="loadMissingTestScores"
            >成绩</span
          >
        </template>
        <template #default="scope">
          <div class="test-score-wrap">
            <span
              class="test-score-cell"
              :class="scoreCellClass(scope.row)"
              @click.stop="loadRowTestScore(scope.row)"
            >
              <template v-if="scope.row.status !== 'finished'">—</template>
              <template v-else-if="scoreState(scope.row).loading">加载中</template>
              <template v-else-if="scoreLines(scope.row).length">
                <span
                  v-for="(line, index) in scoreLines(scope.row)"
                  :key="index"
                  class="test-score-line"
                  :class="line.pass ? 'is-pass' : 'is-fail'"
                  >{{ line.text }}</span
                >
              </template>
              <template v-else>查看</template>
            </span>
            <el-button
              v-if="hasScore(scope.row)"
              size="small"
              text
              type="primary"
              class="test-score-copy"
              @click.stop="copyScore(scope.row)"
              >复制</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column align="right" v-if="userRole != 'Student'">
        <template #default="scope">
          <el-button
            size="small"
            type="success"
            @click.stop="handlePublish(scope.row)"
            v-show="scope.row.published == false"
            >Publish</el-button
          >
          <el-button
            size="small"
            type="success"
            @click.stop="handleDuplicate(scope.row)"
            >Dolly</el-button
          >
          <el-button
            v-if="userRole != 'Student' && scope.row.status != 'finished'"
            size="small"
            type="success"
            @click.stop="handleUpdateAsFinished(scope.row)"
            >Terminator</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click.stop="handleDelete(scope.$index, scope.row)"
            >Delete</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <duplicate-test-form
      v-model="showCreateTestForm"
      :originalTestInfo="currentRowInfo"
      @on-test-mode-form-cancel="showCreateTestForm = false"
      @on-test-mode-form-confirm="showCreateTestForm = false"
      @on-tool-config-form-close="showCreateTestForm = false"
    ></duplicate-test-form>

    <duplicate-multiple-tests
      v-model="showDuplicateMultipleTestForm"
      :multipleSelectedTests="multipleSelectedTests"
      @on-duplicate-multiple-form-cancel="showDuplicateMultipleTestForm = false"
      @on-duplicate-multiple-form-confirm="
        showDuplicateMultipleTestForm = false
      "
      @on-duplicate-multiple-form-close="showDuplicateMultipleTestForm = false"
    ></duplicate-multiple-tests>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import DuplicateTestForm from "./DuplicateTestForm.vue";
import duplicateMultipleTests from "./DuplicateMultipleTests.vue";
import { summarizeTestScore, testScoreKey } from "../../../utils/testScore";

export default {
  name: "TestList",

  props: ["targetId"],

  components: { DuplicateTestForm, duplicateMultipleTests },

  computed: {
    ...mapGetters("StudentTest", ["testList"]),
    ...mapMutations("StudentTest", ["mutateTestList"]),
    // 从列表里提取所有不重复的来源，供下拉筛选
    originOptions() {
      const set = new Set();
      (this.testList || []).forEach((t) => {
        if (t.origin && String(t.origin).trim()) {
          set.add(String(t.origin).trim());
        }
      });
      return Array.from(set).sort();
    },
    filterTestList() {
      const qOrigin = (this.searchOrigin || "").trim();
      const qName = (this.searchName || "").trim().toLowerCase();
      return this.testList.filter((data) => {
        const okOrigin =
          !qOrigin ||
          (data.origin && String(data.origin).trim() === qOrigin);
        const okName =
          !qName ||
          (data.name != null &&
            String(data.name).toLowerCase().includes(qName));
        return okOrigin && okName;
      });
    },
  },

  mounted: function () {
    this.userRole = localStorage.getItem("userRole");
    this.getStudentTestList();
    this.getAllTeachersAndAdmins();
  },

  data() {
    return {
      searchOrigin: "",
      searchName: "",
      userRole: "",
      showCreateTestForm: false,
      showDuplicateMultipleTestForm: false,
      currentRowInfo: null,
      currentViewingTeacherId: null,
      teachersAndAdmins: [],
      multipleSelectedTests: [],
      testScoreMap: {},
      scoreBatchLoading: false,
    };
  },

  methods: {
    openAsNewPageWithCryption: function (routeName, query) {
      query = JSON.stringify(query);
      query = window.encodeURIComponent(query);
      let newpage = this.$router.resolve({
        path: routeName,
        query: { encodedString: window.btoa(query) },
      });
      window.open(newpage.href, "_blank");
    },

    OpenInCurrentPageWithCryption: function (routeName, query) {
      query = JSON.stringify(query);
      query = window.encodeURIComponent(query);
      this.$router.push({
        path: routeName,
        query: { encodedString: window.btoa(query) },
      });
    },

    getAllTeachersAndAdmins: function () {
      this.$store.dispatch("Admin/getAllTeachersAndAdmins").then((response) => {
        this.teachersAndAdmins = response.data;
        this.processTeachersAndAdminsList();
      });
    },

    processTeachersAndAdminsList: function () {
      //去掉 angas
      this.teachersAndAdmins = this.teachersAndAdmins.filter(
        (item) => item.userName.trim() != "angas"
      );
    },

    //get test list based on teacher id
    handleSelectTeacherChange: function (teacherId) {
      this.testScoreMap = {};
      this.$store.dispatch("StudentTest/getAllTestsByUserId", {
        userId: teacherId,
      });
    },

    getStudentTestList: function () {
      this.testScoreMap = {};
      this.$store.dispatch("StudentTest/getAllTestByStudentId", {
        userId: this.targetId || localStorage.getItem("targetId"),
        userRole: this.userRole,
      });
    },

    isAndoverAssigned: function (row) {
      return Number(row && row.createdBy) === -1;
    },

    scoreState: function (row) {
      return this.testScoreMap[testScoreKey(row)] || {};
    },

    scoreLines: function (row) {
      const state = this.scoreState(row);
      if (Array.isArray(state.lines) && state.lines.length) {
        return state.lines;
      }
      if (!state.text) return [];
      return String(state.text)
        .split("\n")
        .filter((line) => line.trim())
        .map((line) => {
          const match = line.match(/([\d.]+)\s*%/);
          const percent = match ? Number(match[1]) : null;
          return {
            text: line,
            pass: percent != null ? percent >= 90 : !!state.pass,
          };
        });
    },

    scoreCellClass: function (row) {
      if (row.status !== "finished") return "is-disabled";
      const state = this.scoreState(row);
      if (state.text || (state.lines && state.lines.length)) return "has-score";
      return "is-pending";
    },

    // 是否有可复制的成绩
    hasScore: function (row) {
      const state = this.scoreState(row);
      return !!(state.text || (state.lines && state.lines.length));
    },

    // 复制成绩到剪贴板
    copyScore: function (row) {
      const state = this.scoreState(row);
      const lines = this.scoreLines(row);
      const text =
        state.text || (lines.length ? lines.map((l) => l.text).join("\n") : "");
      if (!text) {
        this.$message.info("暂无成绩可复制");
        return;
      }
      const fallback = () => {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand("copy");
          this.$message.success("成绩已复制到剪贴板");
        } catch (e) {
          this.$message.error("复制失败，请手动复制");
        }
        document.body.removeChild(ta);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => this.$message.success("成绩已复制到剪贴板"))
          .catch(fallback);
      } else {
        fallback();
      }
    },

    loadRowTestScore: async function (row) {
      if (row.status !== "finished") return;
      const key = testScoreKey(row);
      const current = this.testScoreMap[key] || {};
      if (current.loading) return;
      this.testScoreMap = {
        ...this.testScoreMap,
        [key]: { ...current, loading: true },
      };
      try {
        const response = await this.$store.dispatch(
          "StudentTest/getTestById",
          {
            id: row.id,
            userId: row.studentId,
          }
        );
        const summary = summarizeTestScore(response.data);
        this.testScoreMap = {
          ...this.testScoreMap,
          [key]: {
            text: summary.scoreText,
            pass: summary.scorePass,
            lines: summary.lines || [],
            loading: false,
          },
        };
      } catch (error) {
        this.testScoreMap = {
          ...this.testScoreMap,
          [key]: { loading: false, text: "加载失败", pass: false },
        };
        this.$message((error && error.message) || error.toString());
      }
    },

    loadMissingTestScores: async function () {
      const rows = this.filterTestList.filter((row) => {
        if (row.status !== "finished") return false;
        const state = this.scoreState(row);
        return !state.text && !state.loading;
      });
      if (!rows.length) {
        this.$message.info("已完成测试的成绩都已显示");
        return;
      }
      if (this.scoreBatchLoading) return;
      this.scoreBatchLoading = true;
      const batch = rows.slice(0, 10);
      try {
        for (const row of batch) {
          await this.loadRowTestScore(row);
        }
        const remain = rows.length - batch.length;
        if (remain > 0) {
          this.$message.success(
            `已加载 ${batch.length} 条成绩，还有 ${remain} 条可继续点击表头加载`
          );
        }
      } finally {
        this.scoreBatchLoading = false;
      }
    },

    //handleTestListRowClick: function (row, column, event, payload) {
    handleTestListRowClick: function (row) {
      //加入学生名字
      row.targetCNName =
        localStorage.getItem("targetCNName") ||
        localStorage.getItem("userCNName");
      //标记打开测试的用户是否是自己（如果不是，就是老师绑定了学生，那么不允许“提交”等操作
      row.isSelf =
        localStorage.getItem("userId") == localStorage.getItem("targetId");
      //如果是学生打开，且是第一次打开（status是standing证明是第一次打开），就更新status到pending
      if (
        localStorage.getItem("userRole") == "Student" &&
        row.status == "standing"
      ) {
        this.$store
          .dispatch("StudentTest/updateStudentTestStatus", {
            id: row.id,
            studentId: row.studentId,
            name: row.name,
            type: row.type,
            origin: row.origin,
            nirvanaCount: 0,
            description: row.description || "",
            status: "pending",
            published: row.published || true,
          })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => this.$message(error.toString()));
      }

      if (row.type === 5) {
        if (row.status == "finished") {
          this.openAsNewPageWithCryption("/audiotestitemresult", row);
        } else {
          //如果type = 5， 也就是语音测试，就新开audiotestitem页面
          this.openAsNewPageWithCryption("/audiotestitem", row);
        }
      } else if (row.type === 7) {
        if (row.status == "finished") {
          this.openAsNewPageWithCryption("/speakenglishtestitemresult", row);
        } else {
          //如果type = 7， 也就是看英说英测试，就新开speakenglishtestitem页面
          this.openAsNewPageWithCryption("/speakenglishtestitem", row);
        }
      } else {
        if (row.status == "finished") {
          this.openAsNewPageWithCryption("/newtestitemresult", row);
        } else {
          this.openAsNewPageWithCryption("/newtestitem", row);
        }
      }

      // this.$store
      //   .dispatch("AssignmentPractice/getAssignmentQuestion", {
      //     assignmentId: row.id,
      //   })
      //   .then((response) => {
      //     console.log(response);
      //     sessionStorage.setItem(
      //       "completionQuestions",
      //       JSON.stringify(response.data)
      //     );
      //     this.$router.push("/practice");
      //   })
      //   .catch((error) => console.log(error));
    },

    //处理table中选中多行的selection value
    handleSelectionChange: function (val) {
      this.multipleSelectedTests = val;
    },

    duplicateMultipleTests: function () {
      if (this.multipleSelectedTests.length > 0) {
        this.showDuplicateMultipleTestForm = true;
      } else {
        this.$message("请至少选中一个测试");
      }
    },

    // 生成所选测试的报表（按来源/模式/时间趋势可视化 + 错误单词清单）
    generateReport: function () {
      if (this.multipleSelectedTests.length === 0) {
        this.$message("请至少选中一个测试");
        return;
      }
      const tests = this.multipleSelectedTests.map((t) => ({
        id: t.id,
        studentId: t.studentId,
        name: t.name,
        type: t.type,
        origin: t.origin,
        status: t.status,
        startDate: t.startDate,
        endDate: t.endDate,
        createdDate: t.createdDate,
      }));
      this.openAsNewPageWithCryption("/testreport", { tests });
    },

    testTypeString: function (type) {
      switch (type) {
        case 1:
          return "听写英文";
        case 2:
          return "听写中英";
        case 3:
          return "听英写中";
        case 4:
          return "看英写中";
        default:
          return "";
      }
    },

    filterType: function (val, row) {
      return row.type == val;
    },

    filterStatus: function (val, row) {
      return row.status == val;
    },

    filterCategory: function (val, row) {
      if (val == "None") return row.category == "" || row.category == null;
      return row.category == val;
    },

    clearFilter: function () {
      this.$refs.allTestTable.clearFilter();
      this.searchOrigin = "";
      this.searchName = "";
    },

    // 一键只显示与当前行相同来源的测试
    filterByOrigin: function (row) {
      this.searchOrigin = row.origin ? String(row.origin).trim() : "";
    },

    handleDelete: function (index, row) {
      this.$store
        .dispatch("StudentTest/delete", {
          testId: row.id,
        })
        .then((response) => {
          console.log(response);
          this.testList.splice(index, 1);
        })
        .catch((error) => this.$message(error.toString()));
    },

    handleDuplicate: function (row) {
      this.currentRowInfo = row;
      console.log(this.currentRowInfo);
      this.showCreateTestForm = true;
    },

    handleUpdateAsFinished: function (row) {
      row.status = "finished";
      this.$store.dispatch("StudentTest/updateStudentTestStatus", row);
    },

    handlePublish: function (row) {
      console.log(row);
      this.$store
        .dispatch("StudentTest/publishStudentTest", {
          id: row.id,
          studentId: row.studentId,
          published: true,
        })
        .then((response) => {
          console.log(response);
          this.$message({
            type: "success",
            message:
              localStorage.getItem("targetCNName") +
              "的测试: " +
              row.name +
              "已发布",
          });
          row.published = true;
        })
        .catch((error) => this.$message(error.toString()));
    },

    //tableRowClassName: function ({ row, rowIndex }) {
    tableRowClassName: function ({ row }) {
      const classes = [];
      if (row.status == "pending") {
        classes.push("warning-row");
      } else if (row.status == "finished") {
        classes.push("success-row");
      }
      if (this.isAndoverAssigned(row)) {
        classes.push("andover-assigned-row");
      }
      return classes.join(" ");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}
.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}
.el-table .andover-assigned-row td:first-child {
  box-shadow: inset 3px 0 0 #e6a23c;
}
.test-list-name-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-align: left;
}
.andover-test-tag {
  flex-shrink: 0;
}
.test-list-name-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: stretch;
}
.test-list-name-header > span {
  font-size: 12px;
  line-height: 1.2;
}
.test-list-name-header .el-input {
  width: 70%;
}
.test-score-header {
  cursor: pointer;
  color: #409eff;
  user-select: none;
}
.test-score-header:hover {
  text-decoration: underline;
}
.test-score-cell {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  line-height: 1.3;
  cursor: pointer;
  user-select: none;
}
.test-score-cell.is-disabled {
  cursor: default;
  color: #c0c4cc;
}
.test-score-cell.is-pending {
  color: #409eff;
}
.test-score-line {
  display: block;
  font-weight: 600;
}
.test-score-line.is-pass {
  color: #67c23a;
}
.test-score-line.is-fail {
  color: #f56c6c;
}
.test-score-wrap {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.test-score-copy {
  flex-shrink: 0;
  margin-top: -2px;
  padding: 0 2px;
}
.test-list-origin-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: stretch;
}
.test-list-origin-label {
  font-size: 12px;
  line-height: 1.2;
  color: #909399;
}
.test-list-origin-select {
  width: 100%;
}
.test-list-origin-pop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.test-list-origin-pop-text {
  max-width: 360px;
  word-break: break-all;
}
.test-list-origin-ref {
  cursor: default;
}
</style>
